import React, { Component } from "react";
import AntdButton, { ButtonProps } from "antd/lib/button";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/button/style";

const { Group } = AntdButton;
export default class Button extends Component<ButtonProps> {
  static Group = Group;
  render() {
    const { children } = this.props;
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="Button"
              {...this.props}
              render={eventprops => (
                <AntdButton {...this.props} {...eventprops} data-ui-role='Button'>
                  {children}
                </AntdButton>
              )}
            ></PagePoint>
          ) : (
            <AntdButton {...this.props}>{children}</AntdButton>
          )
        }
      </ConfigConsumer>
    );
  }
}

export { ButtonProps };



// WEBPACK FOOTER //
// ./src/components/button/index.tsx